module.exports = [{
      plugin: require('/home/simon/projects/allabout.school/node_modules/gatsby-plugin-typography/gatsby-browser'),
      options: {"plugins":[],"pathToConfigModule":"src/utils/typography.js"},
    },{
      plugin: require('/home/simon/projects/allabout.school/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
